'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n'], ['\n  width: ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledSVG = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width ? props.width : '1.5rem';
});
var StyledPath = _styledComponents2.default.path(_templateObject2, function (props) {
  return props.theme.color_blue;
});
var StyledPlygon = _styledComponents2.default.polygon(_templateObject2, function (props) {
  return props.theme.color_blue;
});
var EditSVG = function EditSVG(props) {
  return _react2.default.createElement(StyledSVG, Object.assign({
    viewBox: '0 0 632 667'
  }, props), _react2.default.createElement(StyledPlygon, {
    points: '514,588 95,587 94,169 421.5,169 448.5,139 66.1,139.1 66.1,615.9 542.9,615.9 543,214 513.5,247.3 \r '
  }), _react2.default.createElement(StyledPath, {
    d: 'M543.7,70.1c26.6,2.2,47.8,22.2,52.4,48.1l-24.6,27.6l-53.3-47.3l53.3,47.3l-53.3-47.3L543.7,70.1L543.7,70.1\r z'
  }), _react2.default.createElement(StyledPlygon, {
    points: '252.8,449.6 325.4,422.6 547.8,173.4 495,126.2 273.1,374.6'
  }), _react2.default.createElement('line', {
    className: 'st1',
    x1: '566.5',
    y1: '93.7',
    x2: '516.3',
    y2: '149.9'
  }));
};
exports.default = EditSVG;